import { ModalProgrammatic as Modal } from 'buefy';
import mixpanel from 'mixpanel-browser';

import customFetch from '../customFetch';

const mixToken = process.env.VUE_APP_MIXPANEL_TOKEN;
mixpanel.init(mixToken);

function serialize(obj) {
  const str = Object.keys(obj).reduce((accum, key) => {
    if (obj[key] != null) {
      accum.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    }
    return accum;
  }, []);
  return `?${str.join('&')}`;
}

const API_URL = process.env.VUE_APP_MACHETE_OPS_API;
const API_BANNER_URL = process.env.VUE_APP_MACHETE_BANNERS_API;
const API_URL_INVOICE = process.env.VUE_APP_MACHETE_INVOICE_API;
const INVOICE_PDF = `${API_URL_INVOICE}/parse/json-to-xml-string`;
const INVOICE_BY_UUID = `${API_URL}/invoice/uuid/:uuid`;
const INVOICE_SAVE = `${API_URL}/invoice/company/:company`;
const SALE_NOTE_URL = `${API_URL}/invoice/sale-note/company/:company`;
const SAVE_AUTO_INVOICE = `${API_URL}/invoice/company/auto/:company`;
const GET_AUTO_INVOICE_BY_TOKEN = `${API_URL}/customer/invoice/auto`;
const GET_ALL = `${API_URL}/invoices/:company`;
// const GET_STATUS_ACCOUNT = `${API_URL}/invoices/:company/account/:customer`;
const CUSTOMER_AUTO_INVOICE = `${API_URL}/customer/invoice/auto/:invoice`;
const STAMP_CANCEL = `${API_URL}/invoice/uuid/:uuid/stamp`;
const SALE_NOTE_CANCEL = `${API_URL}/sale-note/uuid/:uuid`;
const GET_ASSET = `${API_URL}/assets/:type/uuid/:uuid`;
const GET_CUSTOMER_ASSET = `${API_URL}/assets-customer/:type/uuid/:uuid`;
const DOWNLOAD_FILE = `${API_URL}/download`;
const DOWNLOAD_FILE_CUSTOMER = `${API_URL}/download-customer-asset`;
const RESEND_ASSETS_EMAIL = `${API_URL}/email/assets/resend/:uuid`;
const INVOICE_DELETE_UUID = `${API_URL}/pre-invoice/:uuid`;
const URL_SALARY_RECEIPT = `${API_URL}/invoice/salary-receipt/company/:company`;
const URL_BANNER = `${API_BANNER_URL}/:type`;
const OFFSET_TIMEZONE = `${API_URL}/datetime/:zipcode`;
const DOCUMENT_STATUS = `${API_URL}/invoice/:uuid/status`;
const UPDATE_CANCELLATION = `${API_URL}/invoice/:uuid/cancellation`;

const iframe = `
  <div class="manifesto-container">
    <iframe
      class="manifesto"
      src="https://www.cfdi.com.mx/manifiesto"
      frameborder="0"
      width="400px"
      height="600px"
    ></iframe>
  </div>
`;

export default {
  async save(company, body, stamp, isSaleNote) {
    const URL_INVOICE = isSaleNote ? SALE_NOTE_URL : INVOICE_SAVE;
    const { subscriberId } = body;
    if (subscriberId) delete body.subscriberId;

    try {
      const response = await customFetch(URL_INVOICE, {
        method: 'POST',
        body: JSON.stringify(body),
        params: { company },
        query: { stamp },
      });

      const payload = await response.json();

      // eslint-disable-next-line no-underscore-dangle
      const cfdi = payload.payload._doc || null;
      if (cfdi) {
        if (cfdi.voucherType === 'I' && !cfdi.operation.isSaleNote) {
          mixpanel.track('Factura', { distinct_id: subscriberId || cfdi.emitterRfc });
        }
        if (cfdi.voucherType === 'P') {
          mixpanel.track('Rep', { distinct_id: subscriberId || cfdi.emitterRfc });
        }
        if (cfdi.voucherType === 'N' && !cfdi.operation.isSalaryReceipt) {
          mixpanel.track('Nómina', { distinct_id: subscriberId || cfdi.emitterRfc });
        }
        if (cfdi.voucherType === 'E') {
          mixpanel.track('Nota de crédito', { distinct_id: subscriberId || cfdi.emitterRfc });
        }
      }
      return payload;
    } catch (error) {
      const needManifesto = error.status === 412;

      if (needManifesto) {
        Modal.open(iframe);
        mixpanel.track('errorManifesto',
          {
            distinct_id: subscriberId || body.emitterRfc,
            name: body.emitterName,
          });
      }
      throw error;
    }
  },

  async saveSalaryReceipt(company, body) {
    const response = await customFetch(URL_SALARY_RECEIPT, {
      method: 'POST',
      body: JSON.stringify(body),
      params: { company },
    });

    const payload = await response.json();

    return payload;
  },

  async auto(company, body) {
    const response = await customFetch(SAVE_AUTO_INVOICE, {
      method: 'POST',
      body: JSON.stringify(body),
      params: { company },
    });

    const { payload } = await response.json();

    return payload;
  },

  async verifyAutoInvoiceToken(token) {
    const response = await fetch(`${GET_AUTO_INVOICE_BY_TOKEN}`, {
      method: 'GET',
      headers: { authorization: token },
    });

    const { payload } = await response.json();

    return payload;
  },

  async getAll(company, filter, page, size, query) {
    const response = await customFetch(GET_ALL, {
      method: 'GET',
      params: { company },
      query: {
        filter,
        page,
        size,
        ...query,
      },
    });

    if (query.download) {
      return response.blob();
    }

    const { payload } = await response.json();

    return payload;
  },

  async getStatusAccount(company, customer, page, size, query, token) {
    const $query = {
      page,
      size,
      ...query,
    };

    const response = await fetch(`${API_URL}/invoices/${company}/account/${customer}${serialize($query)}`, {
      method: 'GET',
      headers: { authorization: token },
    });

    const { payload } = await response.json();

    return payload;
  },

  async getCustomerAutoInvoice(invoice) {
    const response = await customFetch(CUSTOMER_AUTO_INVOICE, {
      method: 'GET',
      params: { invoice },
    });

    const { payload } = await response.json();
    return payload;
  },

  async getBanner(position, view) {
    const composedType = `${view}-${position}`;
    const response = await customFetch(URL_BANNER, {
      method: 'GET',
      params: { type: composedType },
    });

    let result = null;

    try {
      result = await response.json();
    } catch (e) {
      result = {};
    }

    return result;
  },

  async updateCustomerAutoInvoice(invoice, receiver, stamp) {
    const response = await customFetch(CUSTOMER_AUTO_INVOICE, {
      method: 'PUT',
      params: { invoice },
      body: JSON.stringify(receiver),
      query: { stamp },
    });

    const { payload } = await response.json();
    return payload;
  },

  async getByUuid(uuid) {
    const response = await customFetch(INVOICE_BY_UUID, {
      method: 'GET',
      params: { uuid },
    });

    const { payload } = await response.json();

    return payload;
  },

  async updateByUuid(uuid, invoice, stamp) {
    try {
      const { subscriberId } = invoice;
      if (subscriberId) delete invoice.subscriberId;

      const response = await customFetch(INVOICE_BY_UUID, {
        method: 'PUT',
        params: { uuid },
        body: JSON.stringify(invoice),
        query: { stamp },
      });

      const { payload } = await response.json();

      return payload;
    } catch (error) {
      const needManifesto = error.status === 412;

      if (needManifesto) {
        const { subscriberId } = invoice;
        if (subscriberId) delete invoice.subscriberId;
        mixpanel.track('errorManifesto',
          {
            distinct_id: subscriberId || invoice.emitterRfc,
            name: invoice.emitterName,
          });
        Modal.open(iframe);
      }
      throw error;
    }
  },

  async cancelByUuid(uuid) {
    try {
      const response = await customFetch(STAMP_CANCEL, {
        method: 'DELETE',
        params: { uuid },
      });

      const { payload } = await response.json();

      return payload;
    } catch (error) {
      const needManifesto = error.status === 412;

      if (needManifesto) Modal.open(iframe);

      throw error;
    }
  },

  async cancelSaleNoteByUuid(uuid, isSalaryReceipt = false) {
    const data = {
      method: 'DELETE',
      params: { uuid },
    };

    if (isSalaryReceipt) data.query = { isSalaryReceipt };

    const response = await customFetch(SALE_NOTE_CANCEL, data);

    const { payload } = await response.json();

    return payload;
  },

  async getAsset(type, uuid, customerDownload = false) {
    let assetsUrl = GET_ASSET;

    if (customerDownload) {
      assetsUrl = GET_CUSTOMER_ASSET;
    }

    const response = await customFetch(`${assetsUrl}`, {
      method: 'GET',
      params: { type, uuid },
    });

    const { payload } = await response.json();
    return payload;
  },

  async downloadFile(filePath, customerDownload = false) {
    let downloadUrl = DOWNLOAD_FILE;

    if (customerDownload) {
      downloadUrl = DOWNLOAD_FILE_CUSTOMER;
    }

    const response = await customFetch(`${downloadUrl}`, {
      method: 'POST',
      body: JSON.stringify({ url: filePath }),
    });

    const payload = await response.blob();
    return payload;
  },

  async resendAssetsEmail(uuid) {
    const response = await customFetch(`${RESEND_ASSETS_EMAIL}`, {
      method: 'GET',
      params: { uuid },
    });

    const { payload } = await response.json();
    return payload;
  },

  async deleteByUuid(uuid) {
    const response = await customFetch(INVOICE_DELETE_UUID, {
      method: 'DELETE',
      params: { uuid },
    });

    const { payload } = await response.json();

    return payload;
  },
  async regeneratePdf(body) {
    const zipcode = body.invoice.voucherExpeditionPlace;
    const response1 = await customFetch(OFFSET_TIMEZONE, {
      method: 'GET',
      params: { zipcode },
    });
    const currentTime = await response1.json();
    body.currentTime = currentTime.payload;
    const response = await customFetch(INVOICE_PDF, {
      method: 'POST',
      body: JSON.stringify(body),
    });

    const { payload } = await response.json();

    return payload;
  },

  async updateCfdiStatus(uuid) {
    const response = await customFetch(DOCUMENT_STATUS, {
      method: 'PUT',
      params: { uuid },
    });

    const { payload } = await response.json();

    return payload;
  },

  async updateCancellation(uuid, cancellation) {
    const response = await customFetch(UPDATE_CANCELLATION, {
      method: 'PUT',
      params: { uuid },
      query: cancellation,
    });

    const { payload } = await response.json();

    return payload;
  },
};
